export { ImagePolicyPage as default } from '@/components/pages/Legal/ImagePolicy'
